import axios from "axios";
import config from "services/config";

export class UserService {
  static async delete({ user_id }) {
    try {
      const { data } = await axios.delete(
        `${config.url}/users/delete/${user_id}`
      );
      console.log(data);
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async create(payload) {
    console.log({ payload });
    try {
      const { data } = await axios.post(
        `${config.url}/users/create/`,
        payload,
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async edit(userId, payload) {
    try {
      const { data } = await axios.post(
        `${config.url}/users/edit/${userId}`,
        payload,
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
}
